<template>
  <div class="fifth">
    <div class="honor-container">
      <el-carousel :interval="2000" :arrow="'always'" height="40vh" :autoplay="true">
        <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
          <div class="honor-img">
            <img v-lazy="require(`@/assets/${item.src}`)" :alt="item.alt" class="carousel-img" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carouselItems: [
        { src: 'honor1.jpg', alt: 'honor1' },
        { src: 'honor2.jpg', alt: 'honor2' },
        { src: 'honor3.jpg', alt: 'honor3' },
        { src: 'honor4.jpg', alt: 'honor4' },
        { src: 'honor5.jpg', alt: 'honor5' },
        { src: 'honor6.jpg', alt: 'honor6' },
      ],
    };
  },
};
</script>

<style scoped>
.honor-container {
  width: 100%;
  max-width: 100%;
}

.honor-img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例，完整显示 */
  display: block;
  margin: 0 auto;
}
</style>
